import "./Modal.css";

const KeyModal = ({ onClose, data }) => {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <span style={{ color: "red" }}>
          Save this key for future refernce, If the key is lost please use the
          rotate functionality to generate a new api key.
        </span>
        <br />
        <div style={{ marginTop: "10px" }}>
          <strong>API Key:</strong>
          <div style={{ wordBreak: "break-all" }}>{data?.apiKey}</div>
        </div>
         {data?.aesKey && (
          <div style={{ marginTop: "10px" }}>
            <strong>AES Key:</strong>
            <div style={{ wordBreak: "break-all" }}>{data?.aesKey}</div>
          </div>
        )}
        <div className="modal-buttons">
          <button type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default KeyModal;
